import { SurveyData } from "@/services/survey-response/models/surveyModels";
import { SurveyRespondeService } from "@/services/survey-response/surveyRespondeService";
import { defineStore } from "pinia";

export const NEW_SURVEY_ID = 'new';

interface State {
    id: number | 'new' | null;
    survey: SurveyData | null;
    fetchingSurveyInfo: boolean;
}

const surveyResponseService = new SurveyRespondeService();

export const useSurveyResponseStore = defineStore({
    id: "surveyResponse",

    state: (): State => ({
        id: null,
        survey: null,
        fetchingSurveyInfo: false,
    }),

    actions: {
        async fetchSurveyResponse() {
            if (!this.id || this.id === NEW_SURVEY_ID) return;
            this.survey = (await surveyResponseService.getSurvey(this.id)) ?? null;
            return this.survey;
        },

        async saveSurveyResponse(surveyData?: SurveyData): Promise<boolean> {
            const data = surveyData || this.survey;
            if (!data) return false;

            const response = await surveyResponseService.saveSurvey(data);
            if (!response) {
                console.error("Error saving survey response");
                return false;
            }

            this.survey = response;
            return true;
        },

        async setId(id: number | 'new' | null) {
            this.id = id;
            this.survey = null;

            if (!this.id) return;

            this.fetchingSurveyInfo = true;
            try {
                await this.fetchSurveyResponse();
            } finally {
                this.fetchingSurveyInfo = false;
            }
        },
    },

    getters: {
        surveyId(): number | undefined {
            return this.survey?.id;
        },
    }
});
